import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceForwardingsValidDirectivesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    workflowId?: string;
  };
  mapper?: (data: any) => T;
  enabled?: boolean;
}

export const useMaintenanceForwardingsValidDirectives = <T,>({
  filters: { search = '', page = 1, workflowId } = {},
  mapper = Mapper.default<T>(),
  enabled,
}: UseMaintenanceForwardingsValidDirectivesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceForwardings', search, page, workflowId],
    queryFn: () => {
      return privateAxios.get(`/maintenance/forwardings/valid_directives`, {
        params: {
          search,
          page,
          workflow_id: workflowId,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    enabled: typeof enabled === 'boolean' ? enabled : true,
  });

  return { data, meta, ...rest }
}
